import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { ventasRoutesMap } from './VentasRoutesMap'

// Carga diferida (lazy loading) de vistas
const AppVentaRegistro = Loadable(lazy(() => import('./view/VentaRegistro')))
const AppVentaGestion = Loadable(lazy(() => import('./view/VentaGestion')))
const AppVentaOfflineRegistro = Loadable(
  lazy(() => import('./view/VentaOfflineRegistro')),
)
const AppVentaGestionOffline = Loadable(lazy(() => import('./view/VentaGestionOffline')))

// Definición de rutas
const ventasRoutes = [
  {
    path: ventasRoutesMap.registro.path || '/ventas/registro',
    element: <AppVentaRegistro />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.gestion.path || '/ventas/gestion',
    element: <AppVentaGestion />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.registroOffline.path,
    element: <AppVentaOfflineRegistro />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.gestionOffline.path,
    element: <AppVentaGestionOffline />,
    auth: authRoles.admin,
  },
]

export default ventasRoutes
